import { Goodfellow } from '@interfaces/goodfellow.interface';

import api from './';

export const { useGetGoodfellowQuery } = api.injectEndpoints({
  endpoints: (build) => ({
    getGoodfellow: build.query<Goodfellow[], void>({
      query: () => ({ url: 'goodfellow' }),
    }),
  }),
});
